import { SoundType } from '../providers/ActivityAudioProvider/types';
import { getAudioAssetPathForKey } from '../util/activities-util';
import GENERIC_SOUNDS from './genericSounds';

export const GameSounds = {
  INTRO: {
    name: 'startingSoundsIntro',
    path: 'data.instructions.introduction',
    category: 'instructions',
  },
  OBJECT_AUDIO: (object: string, objectNumber: number) => ({
    name: `object-${object}`,
    path: `objects[${objectNumber}]`,
    category: 'gameSounds',
  }),
};

const FindTheObjectsTransform = (data: { [key: string]: any }): SoundType[] => {
  const genericSounds = [GENERIC_SOUNDS.SUCCESS, GENERIC_SOUNDS.BOINK];

  const activitySpecificSounds = [GameSounds.INTRO].map((sound) =>
    getAudioAssetPathForKey(data, sound)
  );

  data.objects?.forEach((object, objectIndex) => {
    activitySpecificSounds.push(
      getAudioAssetPathForKey(data, GameSounds.OBJECT_AUDIO(object.description, objectIndex))
    );
  });

  return [...genericSounds, ...activitySpecificSounds];
};

export default FindTheObjectsTransform;
